import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import { TRANSACTION_HISTORY_FILTER_OPTIONS } from '../../../constants/settings';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useTransactionContext } from '../../../contexts/TransactionProvider';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import FilterButton from '../../CommonComps/Buttons/FilterButton';
import CreateEditTransactionModal from '../../CommonComps/Modals/CreateEditTransactionModal';

const TransactionTableToolbar = () => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // integration of context hooks here
  const { currentUserType } = useAuthContext();
  const { transactionType, setTransactionType } = useTransactionContext();

  // rendering transaction table toolbar component here
  return (
    <>
      <div className='flex flex-col md:flex-row items-center justify-end gap-4'>
        <div className='grid grid-cols-[repeat(2,_110px)] md:grid-cols-[repeat(2,_120px)]'>
          {TRANSACTION_HISTORY_FILTER_OPTIONS.map((option) => (
            <FilterButton
              key={option.id}
              keyId={option.id}
              btnText={option.label}
              color={option.color}
              layoutId='filter-transaction-underline'
              selectedValue={transactionType}
              onClick={(type) => setTransactionType(type)}
            />
          ))}
        </div>

        {currentUserType === 'user' ? (
          <AcademiaButton
            type='button'
            onClick={() => setShowModal(true)}
            variant='info'
            icon={<TbSquareRoundedPlusFilled className='size-6' />}
          >
            Create Transaction
          </AcademiaButton>
        ) : null}
      </div>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditTransactionModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default TransactionTableToolbar;
